import { getAppI18nConfig, initI18n } from 'cfgi18n';
import { GetStaticProps } from 'next';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { getSimpleFooter, GetSimpleFooterResponse } from 'services/idm';

import { FormBox } from '@login/components/form-box';
import { FormHeader } from '@login/components/form-header';

import styles from '../../index.module.scss';

const Button = lazy(() => import('core/generic/elements/button'));

export type staticProps = {
	footerData: GetSimpleFooterResponse;
};

export const getStaticProps = (async (params) => {
	const locale = params?.locale as string;
	const { supportedLocales } = await getAppI18nConfig('login');
	await initI18n(locale, supportedLocales);
	const footerData = (await getSimpleFooter(locale)) || [];
	return { props: { footerData, locale } };
}) satisfies GetStaticProps<staticProps>;

const NotFound = ({ locale }: { locale: string }) => {
	const { t } = useTranslation();
	return (
		<Suspense fallback={null}>
			<FormBox>
				<FormHeader headerTitle={t('common.404_error_title')} />
				<div className={styles['not-found']}>
					<div
						className={`body-medium ${styles['not-found__message']}`}
					>
						{t('common.404_error_message')}
					</div>
					<div className={styles['not-found__buttons']}>
						<Button
							type="button"
							label={t('common.404_error_signin_button')}
							variant="primary"
							href="/signin"
							fullWidth={true}
						/>
						<Button
							type="button"
							label={t('common.404_error_register_button')}
							variant="tertiary"
							href="/register"
							fullWidth={true}
						/>
					</div>
				</div>
			</FormBox>
		</Suspense>
	);
};

export default NotFound;
